import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const SettingsMenuSC = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: var(${FIXED_INDENTS.INDENT_20});
  gap: 4px;
  border-radius: 8px;
  background-color: var(${COLOR.SURFACE_DARK_2});

  ${MEDIA.MAX_599} {
    padding: var(${FIXED_INDENTS.INDENT_10});
  }
`

export const SettingsMenuWithDividersSC = styled(SettingsMenuSC)`
  gap: 0;

  & > a {
    display: block;
    padding-bottom: var(${FIXED_INDENTS.INDENT_10});
  }

  & > a + a {
    border-top: 1px solid var(${COLOR.SURFACE_OPACITY_LIGHT_10});
    padding-top: var(${FIXED_INDENTS.INDENT_10});
  }

  & > a:last-child {
    padding-bottom: 0;
  }
`

export const SettingsMenuContainerSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_40});
  width: 100%;

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_50});
  }

  ${MEDIA.MIN_1240} {
    gap: var(${FIXED_INDENTS.INDENT_60});
  }
`
